const { createSlice } = require("@reduxjs/toolkit");

const fbSlice=createSlice({
    name:'fb',
    initialState:{
        fbDetails:null,
        app_fb_user_id:null,
        selectedFbPage:null,
    },
    reducers:{
        setFbDetails(state,action){
            state.fbDetails=action.payload
        },
        setFbUserId(state,action){
            state.app_fb_user_id=action.payload
        },
        setSelectedFbPage(state,action){
            state.selectedFbPage=action.payload
        }
    }
})

export const fbActions=fbSlice.actions;
export default fbSlice;